export default __webpack_public_path__ + "static/media/storageUnit1-afterB-1440w.a0c628ea.avif";